import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/del.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-0f23df36")

_pushScopeId("data-v-0f23df36")
const _hoisted_1 = { class: "bg-ff content" }
const _hoisted_2 = { class: "flex alignC mar-b-30 mar-l-30" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("返回上一级")
const _hoisted_4 = { class: "padding-30" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = { style: {} }
const _hoisted_7 = { class: "flex flexC alignC mar-t-22" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "提交", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("返回")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_11 = { class: "dialog-content" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("搜索")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_editList = _resolveComponent("editList")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back(-1)))
      }, {
        default: _withId(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _withDirectives(_createVNode("div", _hoisted_4, [
      _createVNode(_component_el_form, {
        ref: "formRef",
        model: _ctx.form,
        rules: _ctx.formRules,
        inline: true,
        "label-width": "120px",
        class: "width-900"
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_el_form_item, {
              label: "入库类型",
              prop: "employee_id"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.form.type,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.type = $event)),
                  placeholder: "请选择",
                  class: "width-211"
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList((['退料入库', '辅料退料入库', '其他入库']), (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item,
                        value: index 
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _withDirectives(_createVNode(_component_el_form_item, { label: "退料人" }, {
              default: _withId(() => [
                _createVNode(_component_el_select, {
                  disabled: _ctx.form.type == '2',
                  modelValue: _ctx.form.takeaway,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.takeaway = $event)),
                  filterable: "",
                  placeholder: "请选择",
                  class: "width-211"
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.staff, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item,
                        label: item.nickname,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["disabled", "modelValue"])
              ]),
              _: 1
            }, 512), [
              [_vShow, _ctx.form.type != '2']
            ])
          ]),
          _createVNode("div", null, [
            _withDirectives(_createVNode(_component_el_form_item, {
              label: _ctx.form.type == '1'?'辅料出库单' :'维修车辆'
            }, {
              default: _withId(() => [
                (_ctx.form.type == '1')
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dialog_show_ = 'warehousing')),
                      class: "width-211"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.form.ordersn), 1)
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.dialog_show_ = 'carcode')),
                      class: "width-211"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.form.car_name), 1)
                      ]),
                      _: 1
                    }))
              ]),
              _: 1
            }, 8, ["label"]), [
              [_vShow, _ctx.form.type != '2']
            ]),
            _withDirectives(_createVNode(_component_el_form_item, { label: "成本承担部门" }, {
              default: _withId(() => [
                _createVNode(_component_el_select, {
                  disabled: (_ctx.form.type == '2'),
                  modelValue: _ctx.form.branch_id,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.branch_id = $event)),
                  placeholder: "请选择",
                  class: "width-211"
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.branch, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item,
                        label: item.name,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["disabled", "modelValue"])
              ]),
              _: 1
            }, 512), [
              [_vShow, (_ctx.form.type != '2')]
            ])
          ]),
          _createVNode("div", null, [
            _createVNode(_component_el_form_item, { label: "备注" }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"600px"},
                  modelValue: _ctx.form.desc,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.desc = $event)),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"]),
      _createVNode(_component_editList, {
        class: "mar-t-22",
        partsData: _ctx.form.parts,
        show_add: true,
        onBtn_add: _ctx._editlist_add
      }, {
        default: _withId(() => [
          _createVNode(_component_el_table_column, {
            label: "配件名称",
            "mix-width": "450"
          }, {
            default: _withId((scope) => [
              _createVNode("div", _hoisted_6, [
                _createVNode("img", {
                  onClick: ($event: any) => (_ctx._defItem(scope.$index)),
                  src: _imports_0,
                  class: "wh-24"
                }, null, 8, ["onClick"]),
                _createVNode(_component_el_button, {
                  class: "mar-l-16",
                  style: {"width":"355px"}
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(scope.row.name), 1)
                  ]),
                  _: 2
                }, 1024)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "规格",
            prop: "specification",
            width: "120",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "分类",
            prop: "mountings_type_p_name",
            width: "120",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "品牌",
            prop: "mountings_brand_name",
            width: "120",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "单位",
            prop: "mountings_unit_name",
            width: "120",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "单价",
            width: "120"
          }, {
            default: _withId((scope) => [
              _createVNode(_component_el_input, {
                modelValue: scope.row.unit_price,
                "onUpdate:modelValue": ($event: any) => (scope.row.unit_price = $event),
                type: "text",
                class: "mar-l-16",
                style: {"width":"80px"}
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "数量",
            width: "120"
          }, {
            default: _withId((scope) => [
              _createVNode(_component_el_input, {
                modelValue: scope.row.number,
                "onUpdate:modelValue": ($event: any) => (scope.row.number = $event),
                type: "text",
                class: "mar-l-16",
                style: {"width":"80px"}
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["partsData", "onBtn_add"]),
      _createVNode("div", _hoisted_7, [
        _createVNode(_component_el_button, {
          class: "bg-red",
          onClick: _ctx._onsubmit
        }, {
          default: _withId(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$router.back(-1)))
        }, {
          default: _withId(() => [
            _hoisted_9
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_el_dialog, {
        "model-value": (_ctx.dialog_show_ == 'carcode' || _ctx.dialog_show_ == 'warehousing'),
        width: 500,
        "before-close": ()=>{_ctx.dialog_show_ = ''}
      }, {
        default: _withId(() => [
          _createVNode(_component_el_input, {
            ref: "inputref",
            type: "text",
            "prefix-icon": "el-icon-search",
            style: {"width":"180px"},
            placeholder: _ctx.dialog_show_ == 'carcode' ? '输入车牌号码搜索' : '单据编号/配件',
            modelValue: _ctx.dialog_search,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.dialog_search = $event)),
            onChange: _ctx.get_dialog_data
          }, null, 8, ["placeholder", "modelValue", "onChange"]),
          _createVNode(_component_el_button, {
            class: "mar-l-12",
            onClick: _ctx.get_dialog_data
          }, {
            default: _withId(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["onClick"]),
          (_ctx.dialog_show_ == 'carcode')
            ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                key: 0,
                class: "mar-t-10",
                data: _ctx.dialog_data,
                stripe: "",
                border: "",
                style: {"width":"100%"},
                "max-height": "350",
                onCurrentChange: _ctx._table_select_carcode,
                onSelectionChange: _ctx.handleSelectionChange,
                "header-cell-style": "background-color: #f2f5f9; height: 48px; text-align: center;"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_table_column, {
                    align: "center",
                    prop: "ordersn",
                    label: "单据编号",
                    "min-width": 84
                  }),
                  _createVNode(_component_el_table_column, {
                    align: "center",
                    prop: "car_code",
                    label: "车牌号",
                    "min-width": 84
                  }),
                  _createVNode(_component_el_table_column, {
                    align: "center",
                    prop: "category_name",
                    label: "车辆型号",
                    "min-width": 84
                  }),
                  _createVNode(_component_el_table_column, {
                    align: "center",
                    prop: "meet_vehicle",
                    label: "接车人",
                    "min-width": 84
                  }),
                  _createVNode(_component_el_table_column, {
                    align: "center",
                    prop: "create_time_text",
                    label: "开单时间",
                    "min-width": 84
                  })
                ]),
                _: 1
              }, 8, ["data", "onCurrentChange", "onSelectionChange"])), [
                [_directive_loading, _ctx.dialog_isload]
              ])
            : _createCommentVNode("", true),
          (_ctx.dialog_show_ == 'warehousing')
            ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                key: 1,
                class: "mar-t-10",
                data: _ctx.dialog_data,
                stripe: "",
                border: "",
                style: {"width":"100%"},
                "max-height": "350",
                onCurrentChange: _ctx._table_select_carcode,
                onSelectionChange: _ctx.handleSelectionChange,
                "header-cell-style": "background-color: #f2f5f9; height: 48px; text-align: center;"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_table_column, {
                    align: "center",
                    prop: "record_code",
                    label: "单据编号",
                    "min-width": 84
                  }),
                  _createVNode(_component_el_table_column, {
                    align: "center",
                    prop: "create_time_text",
                    label: "制单时间",
                    "min-width": 84
                  }),
                  _createVNode(_component_el_table_column, {
                    align: "center",
                    prop: "takeaway_text",
                    label: "领料人",
                    "min-width": 84
                  }),
                  _createVNode(_component_el_table_column, {
                    align: "center",
                    prop: "name",
                    label: "配件",
                    "min-width": 130
                  })
                ]),
                _: 1
              }, 8, ["data", "onCurrentChange", "onSelectionChange"])), [
                [_directive_loading, _ctx.dialog_isload]
              ])
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["model-value", "before-close"]),
      _createVNode(_component_el_dialog, {
        center: "",
        title: "添加配件",
        "model-value": _ctx.dialog_show_ == 'parts',
        width: 900,
        "before-close": ()=>{_ctx.dialog_show_ = ''}
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_11, [
            _createVNode(_component_el_input, {
              placeholder: "输入名称搜索",
              class: "width-200",
              modelValue: _ctx.searchKeyWords,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.searchKeyWords = $event)),
              onInput: _ctx.searchMountings,
              clearable: ""
            }, null, 8, ["modelValue", "onInput"]),
            _createVNode(_component_el_button, {
              class: "mar-l-12",
              onClick: _ctx.searchMountings
            }, {
              default: _withId(() => [
                _hoisted_12
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_table, {
              data: _ctx.partsTable,
              stripe: "",
              style: {"width":"100%"},
              class: "table mar-t-12",
              "header-cell-style": _ctx.headClass,
              "highlight-current-row": _ctx.is_all,
              onCurrentChange: _ctx.handleCurrentChange,
              onSelectionChange: _ctx.handleSelectionChange
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.partsColumn, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_table_column, {
                    align: "center",
                    prop: item.prop,
                    label: item.label,
                    "min-width": item.width,
                    key: index
                  }, null, 8, ["prop", "label", "min-width"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["data", "header-cell-style", "highlight-current-row", "onCurrentChange", "onSelectionChange"])
          ])
        ]),
        _: 1
      }, 8, ["model-value", "before-close"])
    ], 512), [
      [_directive_loading, _ctx.is_load]
    ])
  ]))
})